module.exports = __webpack_public_path__ + "img/dataset_obj.9dde2cc2.png";